import { useForm as usePrecognition } from 'laravel-precognition-react';
import { apiUrl } from 'lib.shared/src/api';

type Method = 'get' | 'post' | 'put' | 'patch' | 'delete';

export function usePrecognitionForm<T extends Record<string, unknown>>(
  method: Method,
  path: string,
  initial: T,
) {
  const form = usePrecognition(method, apiUrl(path), initial as Record<string, unknown>);

  const setField = <K extends keyof T>(name: K, value: T[K]) => {
    form.setData(name as string, value as unknown as never);
    form.forgetError(name as string);
  };

  const validateField = <K extends keyof T>(name: K) => form.validate(name as string);

  return Object.assign(form, { setField, validateField, data: form.data as unknown as T });
}
